import gql from 'graphql-tag'

export default gql`
  query SelectVariant {
    productVariants(perPage: 100) {
      nodes {
        id
        title
      }
    }
  }
`
